import { cn } from '@/shared/lib/cn';
import { AppLogo } from '@/shared/ui/app-logo';
import { Card, CardContent } from '@/shared/ui/card';
import { TooltipProvider } from '@/shared/ui/tooltip';
import { Link } from '@inertiajs/react';
import type { HTMLAttributes, ReactNode } from 'react';

interface Props {
    title?: string;
    description?: ReactNode;
    cardContentClass?: HTMLAttributes<HTMLDivElement>['className'];
    children: ReactNode;
}

export default function AuthLayout({ title, description, cardContentClass, children }: Props) {
    return (
        <TooltipProvider delayDuration={200}>
            <div className="flex min-h-svh flex-col items-center justify-center gap-6 bg-background p-6 md:p-10">
                <div className="grid w-full justify-items-center gap-2">
                    <Link href={route('home')} className="flex items-center gap-2">
                        <AppLogo titleClassName="text-lg" />
                    </Link>
                    <Card>
                        <CardContent className={cn('flex w-full max-w-xl flex-col gap-8', cardContentClass)}>
                            {(title || description) && (
                                <div className="flex flex-col items-center gap-4">
                                    <div className="space-y-2 text-center">
                                        {title && <h1 className="text-xl font-medium">{title}</h1>}
                                        {description && <p className="text-center text-sm text-muted-foreground">{description}</p>}
                                    </div>
                                </div>
                            )}
                            {children}
                        </CardContent>
                    </Card>
                </div>
            </div>
        </TooltipProvider>
    );
}
